import React, { Component } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import axios from 'axios';
const validator = require('email-validator');

import LabelledTextInput from '../components/LabelledTextInput';
import Button from '../components/Button';
import MessageSection from '../components/MessageSection';
import Notice from '../components/Notice';
import { MenuItem } from '../components/styled';
import Checkbox from '../../signup/Main/pages/Account/components/Checkbox';

const errorMessages = {
	shopName: 'Invalid shop name',
	name: 'Invalid contact name',
	email: 'Invalid email format',
	contactNumber: 'Invalid contact number',
	// abn: 'ABN must be 11 characters',
	shopZipCode: 'Invalid zip code',
};

const fields = [
	{ name: 'shopName', placeHolder: 'SHOP NAME', type: 'text' },
	{ name: 'name', placeHolder: 'CONTACT NAME', type: 'text' },
	{ name: 'email', placeHolder: 'EMAIL ADDRESS', type: 'email' },
	{ name: 'contactNumber', placeHolder: 'CONTACT NUMBER', type: 'number' },
	{ name: 'shopZipCode', placeHolder: 'SHOP ZIP CODE', type: 'number' },
];

export default class Signup extends Component {
	constructor(props) {
		super(props);

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.validateField = this.validateField.bind(this);

		this.state = {
			submitted: false,
			shopName: '',
			name: '',
			email: '',
			contactNumber: '',
			shopZipCode: '',
			errors: {},
			errorMessage: null,
		};
	}

	onChange(name) {
		return (e) => {
			this.setState({
				[name]: e.target.value,
				errors: {},
				errorMessage: null,
			});
		};
	}

	onSubmit(e) {
		e.preventDefault();

		/* eslint-disable-next-line */
		window.amplitude.getInstance().logEvent('Submit Register your interest Click');

		if (this.state.dataSent) return;
		this.setState({ dataSent: true });

		const errors = {};
		fields.forEach((field) => {
			if (this.validateField(field.name, this.state[field.name])) {
				delete errors[field.name];
			} else {
				errors[field.name] = true;
			}
		});

		if (Object.keys(errors).length > 0) {
			return this.setState({ dataSent: false, errors });
		}

		axios.post('/api/account/us/signup', {
			shopName: this.state.shopName,
			name: this.state.name,
			email: this.state.email,
			contactNumber: this.state.contactNumber,
			// abn: this.state.abn,
			shopZipCode: this.state.shopZipCode,
			// licensedPostOffice: this.state.licensedPostOffice,
		}).then(({ data }) => {
			const errorMessage = data && data.errors && data.errors.error;
			if (!data.success) {
				if (errorMessage === 'existing-account') {
					this.setState({
						dataSent: true,
						submitted: true,
					}, () => {
						setTimeout(() => this.setState({
							submitted: false,
							dataSent: false,
							shopName: '',
							name: '',
							email: '',
							contactNumber: '',
							shopZipCode: '',
							errors: {},
							errorMessage: null,
						}), 3000);
					});
					// return this.setState({
					// 	errorMessage: `${this.state.email} has already been registered.`,
					// 	dataSent: false,
					// }, () => {
					// 	// setTimeout(() => this.setState({
					// 	// 	shopName: '',
					// 	// 	name: '',
					// 	// 	email: '',
					// 	// 	contactNumber: '',
					// 	// 	shopZipCode: '',
					// 	// 	errors: {},
					// 	// 	errorMessage: null,
					// 	// }), 3000);
					// });
				}

				this.setState({ dataSent: false, errorMessage });
			} else {
				this.setState({
					dataSent: true,
					submitted: true,
				}, () => {
					setTimeout(() => this.setState({
						submitted: false,
						dataSent: false,
						shopName: '',
						name: '',
						email: '',
						contactNumber: '',
						shopZipCode: '',
						errors: {},
            errorMessage: null,
					}), 3000);
				});
			}
		}).catch((err) => {
			this.setState({ dataSent: false, error: err });
		});
	}

	validateField(field, value) {
		switch (field) {
			case 'shopName':
				return value.length > 0;
			case 'name':
				return value.length > 0;
			case 'email': {
				const validEmail = validator.validate(value);
				return validEmail;
			}
			case 'contactNumber':
				return value.length > 0;
			// case 'abn':
			// 	return value.length === 11;
			case 'shopZipCode':
				return value.length > 0;
			default:
				return false;
		}
	}

	render () {
		return (
			<Container>
				<Helmet
					title="Signup"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Signup' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
				<HeaderContainer>
					<HeaderSection>
						<LogoContainer>
							<a href="/us/signup"><Image src="/images/redesign/logo.png" /></a>
						</LogoContainer>
						<div>
							<MenuContainer>
								{/* <MenuItem><a href="/agent/faqs">FAQs</a></MenuItem> */}
							</MenuContainer>
						</div>
					</HeaderSection>
				</HeaderContainer>
				<div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
					{!this.state.submitted ? (
						<MessageSection
							style={{ marginTop: '50px' }}
							header="Register your interest"
							paragraph1="Apply below if you would like to become a blueshyft agent:"
						/>
					) : (
						<MessageSection
							header="Thank you!"
							paragraph1="We’ll let you know as soon as we roll out the blueshyft platform in New Jersey, which will contain the next steps!"
							// paragraph1="Your registration is currently pending admin approval."
						/>
					)}
					{this.state.errorMessage && !this.state.submitted ? (
						<div style={{ display: 'flex', justifyContent: 'center', }}>
							<Notice
								color="red"
								text={this.state.errorMessage}
								width="750"
							/>
						</div>
					) : null}
					{!this.state.submitted ? (
						<CenteredContainer>
							<InputContainer>
								{fields.map((field, key) => (
									<Column key={key}>
										<LabelledTextInput
											placeHolder={field.placeHolder}
											name={field.name}
											type={field.type}
											value={this.state[field.name]}
											onChange={this.onChange(field.name)}
											error={this.state.errors[field.name]}
										/>
										{ this.state.errors[field.name] && this.state.errors[field.name] !== 'noop' ? (
											<Notice
												color="red"
												text={this.state.errors[field.name] === true ? errorMessages[field.name] : this.state.errors[field.name]}
												width="95%"
												marginTop="5px"
												// position="absolute"
											/>
										) : null}
									</Column>
								))}
								{/* <Column style={{ width: '946px' }}>
									<Checkbox type="checkbox" name="isLicensed" label="test" checked={this.state.licensedPostOffice} onClick={this.onChange('licensedPostOffice')} style={{ width: '20px' }} /><span style={{ color: '#505d68', fontFamily: '"Karla", sans-serif', fontSize: '16px' }}>I am a Licensed Post Office (LPO)</span>
								</Column> */}
							</InputContainer>
						</CenteredContainer>
					): null}
					<div style={{ marginBottom: -50 }} />
					{!this.state.submitted ? (
						<Button
							text="SUBMIT"
							onSubmit={this.onSubmit} 
						/>
					) : null}
				</div>
			</Container>
		);
	}
};

const InputContainer = styled.div`
	display: flex;
	width: 946px;
	justify-content: space-between;
	margin: 24px;
	flex-wrap: wrap;
`;

const CenteredContainer = styled.div`
	display: flex;
	justify-content: center;
`;

const HeaderContainer = styled.div`
	display: flex;
	justify-content: center;
	border-bottom: 1px solid #dadada;
`;

const HeaderSection = styled.div`
	display: flex;
	// width: 946px;
	width: 100%;
	justify-content: space-between;
	align-items: center;
	height: 50px;
	margin-left: 25px;
	margin-right: 25px;
`;

const LogoContainer = styled.div`
	max-width: 120px;
`;

const MenuContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	
`;

const Column = styled.div`
	// width: 465px;
	// width: 100%;
	width: 48.5%;
	margin-bottom: 20px;
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;



// WEBPACK FOOTER //
// ./client/redesign/web/SignupUS/index.js